"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/list/style");
var _list = _interopRequireDefault(require("antd/lib/list"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
var _react = _interopRequireDefault(require("react"));
var _SearchResult = _interopRequireDefault(require("./SearchResult"));
var _Paginator = _interopRequireDefault(require("./Paginator"));
var _components = require("../../../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SearchResults = function SearchResults(_ref) {
  var searchResults = _ref.searchResults,
    loading = _ref.loading,
    hasMore = _ref.hasMore,
    page = _ref.page,
    prev = _ref.prev,
    next = _ref.next,
    sizeLabel = _ref.sizeLabel,
    onClose = _ref.onClose;
  return /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "channel-search__panel-search-results-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-search__panel-search-results"
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "channel-search__panel-close-row"
  }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: "close-16",
    onClick: onClose,
    className: "channel-search__close-icon"
  })), /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "channel-search__panel-search-results-size"
  }, /*#__PURE__*/_react.default.createElement("span", null, sizeLabel, " results")), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_list.default, {
    dataSource: searchResults,
    loading: loading,
    renderItem: function renderItem(item) {
      return /*#__PURE__*/_react.default.createElement(_list.default.Item, null, /*#__PURE__*/_react.default.createElement(_SearchResult.default, {
        result: item
      }));
    },
    className: "channel-search__results",
    locale: {
      emptyText: 'Nothing found'
    }
  })), /*#__PURE__*/_react.default.createElement(_Paginator.default, {
    hasMore: hasMore,
    prev: prev,
    next: next,
    page: page
  })));
};
var _default = SearchResults;
exports.default = _default;